import React, { Component } from 'react';

class DietTypes extends Component {

  render() {
    let dataArray = this.props.dataArray || {};
    let dietListByGroup =
      dataArray.dietListByGroup || [];

    let dietGroupList =
      this.props.dietGroupList || {};

    let diet = this.props.diet;
    let dietGroup = this.props.diet_group;

    let dietList = [];
    let sampleData = this.props.sampleData || [];
    if (
      dietGroupList &&
      Object.keys(dietGroupList).length > 0
    ) {
      dietList =
        dietGroupList.data || [];
    } else {
      let matchedGroup =
        (dietListByGroup || []).find(
          function(item) {
            return (
              item.id == dietGroup ||
              item.id == 1
            );
          }
        );

      dietList =
        matchedGroup && matchedGroup.data
          ? matchedGroup.data
          : [];
    }
    // console.debug('sampleData');
    // console.debug(sampleData);
    return (
      <section className="path-section">
        <div className="flex_header">
          <div className="step_header">
            <h2>Choose Your Path</h2>
            <p className="subtext avenir-book font-16 deep-grey">
              Find the plan that fits your
              lifestyle and goals.
            </p>
          </div>
        </div>

        <div className="option-grid">
          {dietList.map(
            function(value, index) {
              const handle =
                value.name
                  .replace(/\s+/g, '-')
                  .toLowerCase();
            
              const data = (sampleData&&sampleData[handle]!=undefined)?sampleData[handle]:{};
              const title = value.display_name || value.name;
              return (
                <div
                  className={
                    'path-container ' +
                    (diet == value.id
                      ? 'active'
                      : '')
                  }
                  key={value.id || index}
                >
                  <div className="image_container">
                    <img
                      src={`https://healthyme.basiligo.ae/api/img/${handle}-mealplan.png`}
                      alt={title}
                      width="280"
                      height="280"
                    />
                  </div>

                  <div className="varint-det">
                    <div className="price-badge">
                      Starting at{' '}
                      <span className="avenir-heavy startprice">
                        AED {data.startprice}
                      </span>
                      /day
                    </div>

                    <div className="variant_infor">
                      <div className="var-nam avenir-heavy font-16">
                        <span className="avenir-heavy font-16">
                          {title}
                        </span>

                        <p className="tag_line avenir-roman font-13">
                         {data.description}
                        </p>

                        <div className="avenir-roman mobile_startprice">
                          <p>
                            Starting at{' '}
                            <span className="avenir-heavy startprice">
                              AED {data.startprice}
                            </span>
                            /day
                          </p>
                        </div>
                      </div>

                      <div className="action_btns">
                        <button
                          type="button"
                          className="openModalBtn avenir-medium font-13"
                          data-optionhandle={
                            handle
                          }
                          onClick={()=>{
                            this.props.renderMealplanPopup(value,handle,data);
                          }}
                        >
                          <div className="marquee-wrapper">
                            <div className="marquee-content">
                              <span>
                                View Macros
                              </span>
                              <span>
                                &amp; Sample Menu
                              </span>
                              <span className="dup">
                                View Macros
                              </span>
                              <span className="dup">
                                &amp; Sample Menu
                              </span>
                            </div>
                          </div>
                        </button>

                        <div
                          className="selectbtn"
                          onClick={function() {
                            this.props.setDietType(
                              value,
                              handle
                            );
                          }.bind(this)}
                        >
                          <label
                            data-value={
                              value.name
                            }
                            htmlFor={handle}
                            className="option-item"
                          >
                            <span className="avenir-medium font-13">
                              Select Plan
                            </span>
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 10.8L3.2 8L2 9.2L6 13.2L14 5.2L12.8 4L6 10.8Z" fill="white"></path>
    </svg>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }.bind(this)
          )}
        </div>
      </section>
    );
  }
}

export default DietTypes;
